import { join } from 'node:path';
import type { PackageJson } from 'type-fest';
import { readJson, writeJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function getDependencies(projectFolder: string) {
  const packageJsonPath = join(projectFolder, 'package.json');
  const packageJson = (await readJson(packageJsonPath)) as PackageJson;
  return Object.entries(packageJson.dependencies ?? {}).map(
    ([name, version]) => ({ name, version })
  );
}

export async function addDependenciesToPackageJson(
  projectFolder: string,
  dependenciesConfig: {
    dependencies: Record<string, string>;
  }
) {
  const packageJsonPath = join(projectFolder, 'package.json');
  const packageJson = (await readJson(packageJsonPath)) as PackageJson;

  if (
    packageJson.dependencies &&
    Object.keys(packageJson.dependencies).length > 0
  ) {
    throw new CliError({
      code: CliErrorCode.FailedMigrationToAnyNpm(),
      cause: null,
    });
  }

  packageJson.dependencies = {};

  for (const dependencyPackageName of Object.keys(
    dependenciesConfig.dependencies
  )) {
    if (packageJson.devDependencies?.[dependencyPackageName]) {
      delete packageJson.devDependencies[dependencyPackageName];
    }

    packageJson.dependencies[dependencyPackageName] =
      dependenciesConfig.dependencies[dependencyPackageName];
  }

  await writeJson(packageJsonPath, packageJson);
}
